"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _NestedListing = require("./NestedListing");

var _NestedListing2 = _interopRequireDefault(_NestedListing);

var _ThingCommentEntry = require("./ThingCommentEntry");

var _ThingCommentEntry2 = _interopRequireDefault(_ThingCommentEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getChildComments = function getChildComments(replies) {
  return replies && replies.data && replies.data.children || [];
};

var ThingComment = function ThingComment(_ref) {
  var _ref$NestedListing = _ref.NestedListing,
      NestedListing = _ref$NestedListing === undefined ? _NestedListing2.default : _ref$NestedListing,
      _ref$ThingCommentEntr = _ref.ThingCommentEntry,
      ThingCommentEntry = _ref$ThingCommentEntr === undefined ? _ThingCommentEntry2.default : _ref$ThingCommentEntr,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === undefined ? false : _ref$collapsed,
      _ref$replyCount = _ref.replyCount,
      replyCount = _ref$replyCount === undefined ? null : _ref$replyCount,
      props = _objectWithoutProperties(_ref, ["NestedListing", "ThingCommentEntry", "collapsed", "replyCount"]);

  return _react2.default.createElement(
    "div",
    {
      className: ["thing id-t1_h1 comment", props.banned_by && "spam" || "", props.stickied && "stickied" || "", props.controversiality && "controversial" || "", props.score_hidden & "score-hidden" || "", props.distinguished || "", collapsed ? "collapsed" : "noncollapsed"].join(" "),
      "data-author": props.author,
      "data-author-fullname": "t2_19",
      "data-fullname": "t1_h1",
      "data-subreddit": "pics",
      "data-subreddit-fullname": "t4_5",
      "data-type": "comment",
      id: "thing_t1_h1"
    },
    _react2.default.createElement(ThingCommentEntry, _extends({}, props, {
      collapsed: collapsed,
      replyCount: props.replies ? getChildComments(props.replies).length : replyCount
    })),
    _react2.default.createElement(
      "div",
      { className: "child" },
      collapsed ? null : _react2.default.createElement(NestedListing, _extends({}, props, { allChildren: getChildComments(props.replies) }))
    ),
    _react2.default.createElement("div", { className: "clearleft" })
  );
};

exports.default = ThingComment;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/ThingComment.js
// module id = 304
// module chunks = 0